export default {
  domain: 'dev-7yk3bga9.eu.auth0.com',
  clientId: 'tr3hYoR4XJaGrCLHqnMwbtcYW6WDHV2i',
};
